import { httpRequest } from '@/utils/request';
import { TableRequestType, CommonResponse } from '@/types';

/**
 * 设备故障数据接口类型定义
 */
export interface DeviceFaultItem {
  device_sn: string;        // 设备序列号
  product_id: string;       // 产品ID
  fault_code: string;       // 故障代码
  fault_title: string;      // 故障标题
  fault_time: number;       // 故障时间
  created: number;          // 创建时间
}

/**
 * 设备故障列表响应接口
 */
export interface DeviceFaultListResponse {
  success: boolean;
  errorCode: number;
  errorMsg: string;
  result: {
    list: DeviceFaultItem[];
    total: number;
    page: number;
    pageSize: number;
  };
}

/**
 * 设备故障恢复请求参数
 */
export interface DeviceFaultRecoveryRequest {
  operation_type: 'recovery' | 'ignore'; // 操作类型：recovery(恢复) 或 ignore(忽略)
}

/**
 * 获取设备故障列表
 * @param params 查询参数
 */
export function getDeviceFaultList<T>(params: TableRequestType & {
  device_sn?: string;
  product_id?: string;
  fault_code?: string;
}) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/device-fault',
    params,
  });
}

/**
 * 恢复设备故障
 * @param device_sn 设备序列号
 * @param fault_code 故障代码
 */
export function recoverDeviceFault(device_sn: string, fault_code: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device-fault/${device_sn}/${fault_code}/recovery`,
    method: 'POST',
    data: {
      operation_type: 'recovery',
    },
  });
}

/**
 * 忽略设备故障
 * @param device_sn 设备序列号
 * @param fault_code 故障代码
 */
export function ignoreDeviceFault(device_sn: string, fault_code: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device-fault/${device_sn}/${fault_code}/recovery`,
    method: 'POST',
    data: {
      operation_type: 'ignore',
    },
  });
}
